<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
  status: number
}>()

const { t } = useI18n()

const statusConfig = computed(() => {
  switch (props.status) {
    case -1:
      return {
        label: t('status_deleted'),
        class: 'bg-[#FEF0F0] text-[#F56C6C]',
        showDot: true,
        dotClass: 'bg-[#F56C6C]',
      }
    case 4:
      return {
        label: t('status_ready'),
        class: 'bg-[#FDF6EC] text-[#E6A23C]',
        showDot: true,
        dotClass: 'bg-[#E6A23C]',
      }
    case 7:
      return {
        label: t('status_completed'),
        class: 'bg-[#F4F4F5] text-[#909399]',
        showDot: true,
        dotClass: 'bg-[#909399]',
      }
    case 8:
      return {
        label: t('status_cancelled'),
        class: 'bg-[#FEF0F0] text-[#F56C6C]',
        showDot: true,
        dotClass: 'bg-[#F56C6C]',
      }
    case 9:
      return {
        label: t('status_active'),
        class: 'bg-[#E1F3D8] text-[#529B2E]',
        showDot: true,
        dotClass: 'bg-[#529B2E]',
      }
    case 11:
      return {
        label: t('status_paused'),
        class: 'bg-[#FDF6EC] text-[#E6A23C]',
        showDot: true,
        dotClass: 'bg-[#E6A23C]',
      }
    default:
      return {
        label: t('status_unknown'),
        class: 'bg-[#F4F4F5] text-[#909399]',
        showDot: false,
        dotClass: '',
      }
  }
})
</script>

<template>
  <div
    class="px-2 py-0.5 rounded-[32px] text-sm font-normal flex items-center gap-2"
    :class="[statusConfig.class]"
  >
    <span
      v-if="statusConfig.showDot"
      class="w-1 h-1 rounded-full"
      :class="[statusConfig.dotClass]"
    />
    {{ statusConfig.label }}
  </div>
</template>
